import axios from "axios"
import { apiUrl } from "../enumerations/constants"

export const login = async (payload) => {
  const { data: response } = await axios.post(`${apiUrl}/auth/login`, payload)
  return response
}

export const logout = async (payload) => {
  const { data: response } = await axios.post(`${apiUrl}/auth/logout`, payload)
  return response
}

export const validateSession = async (payload) => {
  const { data: response } = await axios.post(`${apiUrl}/auth/validate`, payload)
  return response
}